import { render, staticRenderFns } from "./live_calendar.vue?vue&type=template&id=13fea23a&scoped=true&"
import script from "./live_calendar.vue?vue&type=script&lang=js&"
export * from "./live_calendar.vue?vue&type=script&lang=js&"
import style0 from "./live_calendar.vue?vue&type=style&index=0&id=13fea23a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13fea23a",
  null
  
)

export default component.exports